<template>
  <label
    class="cust-item d-flex align-items-start jcsb"
    :class="[isSelected ? 'border-teal' : '']"
    :for="generateUniqueId(label)"
    :key="generateUniqueId(label)"
  >
    <span class="d-flex align-items-start">
      <i
        class="mr8 mt3"
        :class="[dietType == 'veg' ? 'tag-veg' : 'tag-non-veg']"
        v-if="isCombo"
      ></i>
      <span class="labl-txt fs-14" :class="{ bold: isSelected }">{{
        label || ""
      }}</span>
    </span>
    <span class="d-flex align-items-center">
      <!-- <span
        class="strike-diagonal-price"
        v-if="regularPrice > itemPrice && itemPrice"
      >
        <span class="rs">Rs.</span>{{ regularPrice }}
      </span> -->
      <span class="fs-14 color-slaty ib nowrap pl4" v-if="itemPrice"
        ><span v-if="!isCustomisable">+ </span><span class="rs">Rs.</span
        >{{ itemPrice }}
      </span>

      <!-- Radio ui -->
      <div class="radio-wrapper ml10">
        <label class="radio">
          <input
            type="radio"
            :id="generateUniqueId(label)"
            :name="urlifyName(checkboxName)"
            :value="value"
            :checked="isSelected"
            @change="inputFun"
          />
          <i><span></span></i>
        </label>
      </div>
    </span>
  </label>
</template>

<script>
export default {
  name: "CustomLabelRadio",
  components: {
    //
  },

  data() {
    return {};
  },
  mounted() {},
  model: {
    prop: "value",
    event: ["radioHandler"],
  },
  methods: {
    inputFun(e) {
      this.$emit("radioHandler", {
        value: e.target._value,
        isVeg: this.dietType === "veg",
        label: this.label,
      });
    },
    generateUniqueId(label) {
      return `${label.split(" ").join("-")}-${this.customIndex}`;
    },
    urlifyName(name) {
      return name.trim().split(" ").join("-");
    },
  },
  props: {
    label: { required: false, default: "" },
    customIndex: { required: false, default: "" },
    itemPrice: { required: false, default: "" },
    regularPrice: { required: false, default: "" },
    value: { required: false, default: "" },
    checkboxName: { required: false, default: "" },
    isSelected: { required: false, default: false },
    dietType: { required: false, default: "veg" },
    isCustomisable: { required: false, default: false },
    isCombo: { required: false, default: false },
  },
};
</script>
